// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shop';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.313 9.563v6.75a1.125 1.125 0 0 1-1.125 1.125H2.812a1.125 1.125 0 0 1-1.124-1.125v-6.75m14.173-9H2.139a.563.563 0 0 0-.55.44L.563 5.625a1.687 1.687 0 0 0 3.375 0 1.687 1.687 0 0 0 3.375 0 1.687 1.687 0 0 0 3.375 0 1.687 1.687 0 0 0 3.375 0 1.687 1.687 0 0 0 3.375 0L16.41 1.003a.562.562 0 0 0-.549-.44zM1.688 12.938h9.562m0 4.5V9.563'
  />
);

export const viewBox = '0 0 18 18';
